
import React from 'react';
import { Button } from '@/components/ui/button';
import { CalculatorResults } from '../results/CalculatorResults';
import { EmailResultsDialog } from '../ui/EmailResultsDialog';

interface CalculatorResultsViewProps {
  results: any;
  formData: any;
  onRecalculate: () => void;
}

export function CalculatorResultsView({ 
  results, 
  formData, 
  onRecalculate 
}: CalculatorResultsViewProps) {
  return (
    <div className="p-6">
      <CalculatorResults results={results} formData={formData} />
      
      <div className="mt-6 flex justify-center gap-4">
        <Button
          type="button"
          variant="outline"
          onClick={onRecalculate}
          className="border-grandpal-green text-grandpal-green hover:bg-grandpal-green/10"
        >
          Recalculate
        </Button>
        <EmailResultsDialog results={results} formData={formData} />
      </div>
    </div>
  );
}
